import { Controller } from 'stimulus';
import SignaturePad from 'signature_pad';

class SignatureController extends Controller {
  connect() {
    this.signaturePad = new SignaturePad(this.padTarget, {
      onEnd: () => {
        this.outputData(this.signaturePad.toDataURL());
      },
    });

    this.readData();
  }

  /**
   * Empties the signature pad
   */
  emptySignaturePad() {
    this.signaturePad.clear();
    this.outputData(this.signaturePad.toDataURL());
  }

  /**
   * Output data URL to our hidden input field
   * @param  {string} data
   * @return {void}
   */
  outputData(data) {
    if (!this.hasOutputTarget) {
      throw new Error('Output element doesnt exist!');
    }

    this.outputTarget.value = this.signaturePad.isEmpty() ? '' : data;
  }

  /**
   * Read data from the hidden input field to repopulate the signature
   * @return {void}
   */
  readData() {
    if (typeof this.outputTarget.value !== 'undefined' && this.outputTarget.value) {
      this.signaturePad.fromDataURL(this.outputTarget.value, {
        width: 500,
        height: 281,
      });
    }
  }
}

SignatureController.targets = [
  'pad',
  'output',
];

export default SignatureController;
